const ns = "PEOPLE_BLOCK_PEOPLE";
export const ADD = `${ns}_ADD`;
export const ADD_COMPLETE = `${ns}_ADD_COMPLETE`;
export const REMOVE = `${ns}_REMOVE`;
export const REMOVE_COMPLETE = `${ns}_REMOVE_COMPLETE`;
export const SAVE_VALUE = `${ns}_SAVE_VALUE`;
export const SAVE_VALUE_COMPLETE = `${ns}_SAVE_VALUE_COMPLETE`;
export const BULK_SAVE_VALUES = `${ns}_BULK_SAVE_VALUES`;
export const BULK_SAVE_VALUES_COMPLETE = `${ns}_BULK_SAVE_VALUES_COMPLETE`;
